import React from "react";
import FooterShell from "../shared/FooterShell";
import { MobileFooterVariantProps } from "../shared/types";

/** Home glow — 5 tabs + floating Games FAB + SVG glowing Home arch */
const HomeGlowFooter = (props: Omit<MobileFooterVariantProps, "footerId">) => (
  <FooterShell {...props} footerId="home-arc" />
);

export default HomeGlowFooter;
